<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <span class="navbar-brand" style="cursor: default">{{ routeName + routeShowName }}</span>
      <!--
      <a class="navbar-brand" href="#">{{ routeName + routeShowName }}</a>
      -->
      <button class="navbar-toggler navbar-burger"
              type="button"
              @click="toggleSidebar"
              :aria-expanded="$sidebar.showSidebar"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <span
        class="navbar-brand"
        style="cursor: pointer"
        @click="logout">登出</span>
      <!--
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-panel"></i>
              <p>Stats</p>
            </a>
          </li>
          <drop-down class="nav-item"
                     title="5 Notifications"
                     title-classes="nav-link"
                     icon="ti-bell">
            <a class="dropdown-item" href="#">Notification 1</a>
            <a class="dropdown-item" href="#">Notification 2</a>
            <a class="dropdown-item" href="#">Notification 3</a>
            <a class="dropdown-item" href="#">Notification 4</a>
            <a class="dropdown-item" href="#">Another notification</a>
          </drop-down>
          <li class="nav-item">
            <a href="#" class="nav-link">
              <i class="ti-settings"></i>
              <p>
                Settings
              </p>
            </a>
          </li>
        </ul>
      </div>
      -->
    </div></nav>
</template>
<script>

export default {
  computed: {
    routeShowName() {
      const { name, meta } = this.$route;
      if (meta['name']) {
        return this.capitalizeFirstLetter(meta['name']);
      } else {
        return this.capitalizeFirstLetter(name);
      }
    }
  },
  watch: {
    $route (to, from){
      this.routeName = '';
    }
  },
  data() {
    return {
      activeNotifications: false,
      routeName: '',
      loading: false
    };
  },
  mounted() {
    this.$root.eventBus.$on('routerName', event => {
      console.log(event);
      this.routeName = event + ' 的';
    });
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logout() {
      this.loading = true;
      this.$store.dispatch('LogOut').then(() => {
        this.loading = false;
        this.$router.push({path: '/login'})
      }).catch(() => {
        this.loading = false;
      })
    }
  }
};
</script>
<style>
</style>
